// Simple cart addon functionality
function loadAddonState() {
 try {
   const saved = localStorage.getItem('cart-addon-state');
   if (saved) {
     return JSON.parse(saved);
   }
 } catch (error) {
   console.log('Error loading addon state from localStorage:', error);
 }
 // Default state if no saved state or error
 return {
   safeShip: false,
   mysteryItem: false
 };
}

function saveAddonState() {
 try {
   localStorage.setItem('cart-addon-state', JSON.stringify(addonState));
 } catch (error) {
   console.log('Error saving addon state to localStorage:', error);
 }
}

let addonState = loadAddonState();

// Feature flags
const SAFE_SHIP_ENABLED = false;
const MYSTERY_ITEM_ENABLED = true;

// vip redo product
const SAFE_SHIP_VARIANT_ID = 42329763446850;

// mystery item product
const MYSTERY_ITEM_VARIANT_ID = 42066607374402;

// Add/remove product from cart
async function toggleAddonInCart(variantId, shouldAdd) {
 try {
   if (shouldAdd) {
     await fetch('/cart/add.js', {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({ id: variantId, quantity: 1 })
     });
     
     console.log('Added variant', variantId);
   } else {
     // Get cart and find the item to remove
     const cartResponse = await fetch('/cart.js');
     const cart = await cartResponse.json();
     const item = cart.items.find(item => item.variant_id === variantId);
     
     if (item) {
       await fetch('/cart/update.js', {
         method: 'POST', 
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ updates: { [item.key]: 0 } })
       });
       console.log('Removed variant', variantId);
     }
   }
 } catch (error) {
   console.error('Cart update failed:', error);
 }
}

// Check if products are in cart and sync checkboxes
async function syncCheckboxes() {
 try {
   const cartResponse = await fetch('/cart.js');
   const cart = await cartResponse.json();
   
   if (SAFE_SHIP_ENABLED) {
     const safeShipInCart = cart.items.some(item => item.variant_id === SAFE_SHIP_VARIANT_ID);
     const safeShipCheckbox = document.getElementById("safe-ship-input");
     
     if (safeShipCheckbox && safeShipInCart !== safeShipCheckbox.checked) {
       safeShipCheckbox.checked = safeShipInCart;
       addonState.safeShip = safeShipInCart;
       saveAddonState();
       console.log('Synced Safe Ship checkbox:', safeShipInCart);
     }
   }
   
   if (MYSTERY_ITEM_ENABLED) {
     const mysteryInCart = cart.items.some(item => item.variant_id === MYSTERY_ITEM_VARIANT_ID);
     const mysteryCheckbox = document.getElementById("mystery-item-input");
     
     if (mysteryCheckbox && mysteryInCart !== mysteryCheckbox.checked) {
       mysteryCheckbox.checked = mysteryInCart;
       addonState.mysteryItem = mysteryInCart;
       saveAddonState();
       console.log('Synced Mystery Item checkbox:', mysteryInCart);
     }
   }
 } catch (error) {
   console.error('Sync failed:', error);
 }
}

// Initialize addons when cart changes (items are added) - but only after cart has items
document.addEventListener('rebuy:cart.change', () => {
 setTimeout(() => {
   // Only initialize if not already done and cart has items
   if (!document.body.hasAttribute('data-addon-initialized')) {
     // Check if cart actually has items before initializing
     fetch('/cart.js')
       .then(response => response.json())
       .then(cart => {
         if (cart.item_count > 0) {
           console.log('Initializing cart addons after cart change...');
           initializeCartAddons();
           document.body.setAttribute('data-addon-initialized', 'true');
         }
       })
       .catch(error => console.error('Error checking cart:', error));
   }
 }, 500);
});

// Initialize addons
function initializeCartAddons() {
 console.log('Initializing cart addons...');
 
 setTimeout(async () => {
   const safeShipCheckbox = document.getElementById("safe-ship-input");
   const mysteryCheckbox = document.getElementById("mystery-item-input");
   
   if (!SAFE_SHIP_ENABLED && !MYSTERY_ITEM_ENABLED) {
     console.log('No addons enabled');
     return;
   }

   if (SAFE_SHIP_ENABLED && !safeShipCheckbox) {
     console.log('Safe Ship checkbox not found');
   }

   if (MYSTERY_ITEM_ENABLED && !mysteryCheckbox) {
     console.log('Mystery checkbox not found');
   }

   // Set default state
   if (SAFE_SHIP_ENABLED && safeShipCheckbox) {
     safeShipCheckbox.checked = addonState.safeShip;
   }
   
   if (MYSTERY_ITEM_ENABLED && mysteryCheckbox) {
     mysteryCheckbox.checked = addonState.mysteryItem;
   }
   
   // Add event listeners
   if (SAFE_SHIP_ENABLED && safeShipCheckbox) {
     safeShipCheckbox.addEventListener("change", async function() {
       addonState.safeShip = this.checked;
       saveAddonState();
       console.log('Safe Ship changed:', this.checked);
       await toggleAddonInCart(SAFE_SHIP_VARIANT_ID, this.checked);
     });
   }

   if (MYSTERY_ITEM_ENABLED && mysteryCheckbox) {
     mysteryCheckbox.addEventListener("change", async function() {
       addonState.mysteryItem = this.checked;
       saveAddonState();
       console.log('Mystery Item changed:', this.checked);
       await toggleAddonInCart(MYSTERY_ITEM_VARIANT_ID, this.checked);
     });
   }

   // Check current cart state and sync
   try {
     const cartResponse = await fetch('/cart.js');
     const cart = await cartResponse.json();
     
     let needsToAddSafeShip = false;
     let needsToAddMystery = false;
     
     if (SAFE_SHIP_ENABLED) {
       const safeShipInCart = cart.items.some(item => item.variant_id === SAFE_SHIP_VARIANT_ID);
       needsToAddSafeShip = addonState.safeShip && !safeShipInCart;
     }
     
     if (MYSTERY_ITEM_ENABLED) {
       const mysteryInCart = cart.items.some(item => item.variant_id === MYSTERY_ITEM_VARIANT_ID);
       needsToAddMystery = addonState.mysteryItem && !mysteryInCart;
     }
     
     if (needsToAddSafeShip || needsToAddMystery) {
       // Prevent SmartCart from opening during initial load
       if (window.Rebuy && window.Rebuy.SmartCart) {
         window.Rebuy.SmartCart.skip_open = true;
       }
       
       // Add items that need to be added
       if (needsToAddSafeShip) {
         await toggleAddonInCart(SAFE_SHIP_VARIANT_ID, true);
       }
       
       if (needsToAddMystery) {
         await toggleAddonInCart(MYSTERY_ITEM_VARIANT_ID, true);
       }
       
       // Re-enable SmartCart opening after both items are processed
       setTimeout(() => {
         if (window.Rebuy && window.Rebuy.SmartCart) {
           window.Rebuy.SmartCart.skip_open = false;
         }
       }, 1000);
     }
   } catch (error) {
     console.error('Initial cart sync failed:', error);
   }

   // Monitor cart changes
   document.addEventListener('rebuy:cart.change', () => {
     setTimeout(syncCheckboxes, 200);
   });
   
   console.log('Cart addons initialized');
 }, 500);
}

// Expose for Rebuy callback (if still needed)
window.initializeCartAddons = initializeCartAddons;

// Mystery Item Addon Tooltip - Rebuy ready callback
document.addEventListener("rebuy:cart.ready", function () {
 setTimeout(() => {
   initializeTooltip();
 }, 1000);
});



// Tooltip functionality
function toggleTooltip(btn) {
  const tooltip = btn.nextElementSibling;
  tooltip.classList.toggle("visible");
}

function initializeTooltip() {
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".product__addon-tooltip")) {
      document.querySelectorAll(".product__addon-tooltiptext.visible")
        .forEach(tooltip => tooltip.classList.remove("visible"));
    }
  });
}

document.addEventListener("DOMContentLoaded", initializeTooltip);